import { css as t, styled as r, keyframes as e } from "styled-components";
import { SmallHeavy as n } from "../../styles/typography/index.js";
import { MediaQuery as a } from "../../styles/variables.js";
import { Theme as i } from "../../styles/themes/index.js";
import { Nickname as p } from "../../components/Nickname/index.js";
const g = t`
  padding: 8px 16px 4px 16px;

  @media ${a.SCREEN_MD_UP} {
    padding-right: 24px;
    padding-left: 32px;
  }
`, u = r.button`
  background: none;
  word-break: keep-all;
  display: inline-flex;
  align-items: center;
`, f = r(p)`
  ${n};
  text-decoration: none;
  color: rgb(${i.colors.Alpha});
  cursor: pointer;
`, x = (o) => e`
  from {
    background: rgba(${o}, 1);
  }

  to {
    background: rgba(${o}, 0);
  }`;
export {
  u as ActionsButton,
  f as Author,
  x as createFocusAnimation,
  g as defaultCardSpacing
};
